import moment from 'moment';
import range from 'lodash/range';

module.exports = 'ttb.dashboard.burnDownDiagram.component';

angular.module(module.exports, [])
    .component('burnDownDiagram', {
        template: `<div class="card-box burn-down-diagram">
                       <h4 class="text-dark header-title m-t-0 m-b-30" translate>DashBoard_Burndown_Diagram</h4>
                       <div class="widget-chart text-center">
                           <div>
                               <canvas class ="chart chart-line"
                               chart-data="$ctrl.data" chart-labels="$ctrl.labels" chart-series="$ctrl.series" chart-options="$ctrl.options" chart-dataset-override="$ctrl.datasetOverride"></canvas>
                           </div>
                       </div>
                       <div ng-show="$ctrl.loading" class ="panel-disabled"><div class ="loader-1"></div></div>
                   </div>`,
        controller: BurnDownDiagram,
        bindings: {
            team: '<'
        }
    });

function BurnDownDiagram(burnDownDiagramUrl, $http, $translate) {
    this.$onInit = () => {
        this.initData();
    };

    this.$onChanges = (changes) => {
        if (changes.team) {
            if (changes.team.currentValue !== undefined) {
                this.load(changes.team.currentValue);
            }
            else {
                this.initData();
            }
        }
    }

    this.initData = () => {
        let now = moment();

        this.labels = range(-5, 5).map(day => now.add(day, 'd').format(ttb.constants.dateTime.SHORT_DATE_FORMAT));
        this.data = [[0]];
        this.options = {
            maintainAspectRatio: true,
            scales: {
                yAxes: [
                    {
                           gridLines: {
                            display: true
                        },
                        ticks: {
                            beginAtZero: true,
                            suggestedMax: 50,
                            fontSize: 11
                        }
                    }
                ]
            }
        };
    }

    this.load = (team) => {
        this.loading = true;

        $http.get(burnDownDiagramUrl, { params: { teamId: team ? team.id : null, timestamp: new Date() } })
            .then(response => {
                    this.loading = false;

                    if (response.data) this.buildChart(response.data);
                    else this.initData();
                },
                () => {
                    this.loading = false;
                });
    }

    this.buildChart = (burnDownData) => {
        let points = burnDownData.map(item => item.storyPoint);
        let spentTimes = burnDownData.map(item => item.spentTime);
        let days = burnDownData.map(item => item.time);

        let maxStoryPoint = Math.max(...points);
        let maxSpentTime = Math.max(...spentTimes);
        let max = Math.max(maxStoryPoint, maxSpentTime);

        this.data = [
            points.filter(p => p >= 0),
            spentTimes.filter(p => p >= 0)
        ];

        this.labels = days;

        this.series = [$translate.instant('DashBoard_Burndown_StoryPoints_Legend'), $translate.instant('DashBoard_Burndown_RemainingTime_Legend')];

        this.datasetOverride = [
            {
                type: 'line',
                backgroundColor: 'rgba(59,175,218,0.4)',
                pointBackgroundColor: '#fff',
                pointHoverBackgroundColor: 'rgba(59,175,218,1)',
                borderColor: 'rgba(59,175,218,1)',
                pointBorderColor: 'rgba(59,175,218,1)',
                pointHoverBorderColor: 'rgba(59,175,218,0.8)',
                pointRadius: 3,
                pointBorderWidth: 1.5,
                borderWidth: 1.5
            },
            {
                type: 'line',
                backgroundColor: 'rgba(0,177,157,0.4)',
                pointBackgroundColor: '#fff',
                pointHoverBackgroundColor: 'rgba(0,177,157,1)',
                borderColor: 'rgba(0,177,157,1)',
                pointBorderColor: 'rgba(0,177,157,1)',
                pointHoverBorderColor: 'rgba(0,177,157,0.8)',
                pointRadius: 3,
                pointBorderWidth: 1.5,
                borderWidth: 1.5
            }
        ];

        this.options = {
            legend: { display: true, 
                labels: {
                    fontSize:11
                } 
            },
            tooltips: {
                titleFontSize: 11,
                bodyFontSize: 11
            },
            elements: {
                line: {
                    tension: 0,
                    lineWidth: 1
                }
            },
            animation: {
                duration: 200
            },
            responsiveAnimationDuration: 200,
            maintainAspectRatio: false,
            scales: {
                yAxes: [
                    {
                        gridLines: {
                            display: true,
                            lineWidth: 1
                        },
                        ticks: {
                            beginAtZero: true,
                            fontSize: 11,
                            suggestedMax: max + 5
                        }
                    }
                ],
                xAxes: [
                    {
                        gridLines: {
                            display: true,
                            lineWidth: 1
                        },
                        ticks: {
                            fontSize: 11,
                        }
                    }
                ]
            }
        };
    }
}
BurnDownDiagram.$inject = ['burnDownDiagramUrl', '$http','$translate'];


// WEBPACK FOOTER //
// ./components/burn-down-diagram/burn-down-diagram.component.js